import { createAction } from '@reduxjs/toolkit';

import { REMOVE_ADDRESS_ERROR, SET_ADDRESS_ERROR } from "./addressConstants";


export const removeAddressError = createAction(REMOVE_ADDRESS_ERROR);
export const setAddressError = createAction(SET_ADDRESS_ERROR);
